import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { NavLink } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import { FaChevronDown } from "react-icons/fa";
import logo from "../assets/img/logo.webp";
import "../styles/header.css";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [hideHeader, setHideHeader] = useState(false);
  const navRef = useRef(null);
  const dropdownRef = useRef(null);
  const lastScrollY = useRef(0);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    setIsDropdownOpen(false);
  };

  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

  const closeAllMenus = () => {
    setIsOpen(false);
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }

      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;

      if (currentY > lastScrollY.current && currentY > 100) {
        setHideHeader(true);
      } else {
        setHideHeader(false);
      }

      lastScrollY.current = currentY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const navigate = useNavigate();
  const location = useLocation();

  const handleRegisterClick = () => {
    closeAllMenus(); // đóng menu mobile nếu đang mở

    if (location.pathname === "/") {
      const form = document.getElementById("registration-form");
      if (form) {
        form.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/#registration-form");
    }
  };
  return (
    <header className={`header ${hideHeader ? "header--hidden" : ""}`}>
      <div className="header__container">
        <NavLink
          to="/"
          className="header__logo"
          onClick={closeAllMenus}
        >
          <img
            src={logo}
            alt="Logo"
            className="header__logo-image"
          />
          <span className="header__logo-text">Học viện Design24</span>
        </NavLink>

        <nav
          ref={navRef}
          className={`header__nav ${isOpen ? "header__nav--open" : ""}`}
        >
          <NavLink
            to="/"
            className={({ isActive }) =>
              `header__link ${isActive ? "active" : ""}`
            }
            onClick={closeAllMenus}
          >
            TRANG CHỦ
          </NavLink>

          <NavLink
            to="/about"
            className={({ isActive }) =>
              `header__link ${isActive ? "active" : ""}`
            }
            onClick={closeAllMenus}
          >
            VỀ CHÚNG TÔI
          </NavLink>

          <div
            className="header__dropdown"
            ref={dropdownRef}
          >
            <button
              className={`header__link header__dropdown-toggle ${
                isDropdownOpen ? "active" : ""
              }`}
              onClick={toggleDropdown}
              type="button"
            >
              CHƯƠNG TRÌNH HỌC <FaChevronDown className="header__icon" />
            </button>
            {isDropdownOpen && (
              <div className="header__dropdown-menu">
                <NavLink
                  to="/mc"
                  className={({ isActive }) =>
                    `header__dropdown-item ${isActive ? "active" : ""}`
                  }
                  onClick={closeAllMenus}
                >
                  MC & Diễn viên nhí
                </NavLink>
                <NavLink
                  to="/services"
                  className={({ isActive }) =>
                    `header__dropdown-item ${isActive ? "active" : ""}`
                  }
                  onClick={closeAllMenus}
                >
                  NHÀ THIẾT KẾ TƯƠNG LAI
                </NavLink>
                <NavLink
                  to="/ai-animation"
                  className={({ isActive }) =>
                    `header__dropdown-item ${isActive ? "active" : ""}`
                  }
                  onClick={closeAllMenus}
                >
                  PHIM HOẠT HÌNH Với A.I
                </NavLink>
                <NavLink
                  to="/art"
                  className={({ isActive }) =>
                    `header__dropdown-item ${isActive ? "active" : ""}`
                  }
                  onClick={closeAllMenus}
                >
                  MỸ THUẬT THIẾU NHI
                </NavLink>
              </div>
            )}
          </div>

          <button
            className="header__cta"
            onClick={handleRegisterClick}
          >
            ĐĂNG KÝ NGAY
          </button>
        </nav>

        <div
          className="header__toggle"
          onClick={toggleMenu}
        >
          {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </div>
      </div>
    </header>
  );
};

export default Header;
